import React, { useEffect } from "react";
import { Form, Input, Modal, Switch, Row, Col } from "antd";

const ColorsForm = ({ visible, onCreate, onCancel, record, initialValues }) => {
  const [form] = Form.useForm();

  // ── Populate form when editing, reset when adding ──────────────────────────
  useEffect(() => {
    if (visible) {
      if (record?.id) {
        form.setFieldsValue({
          name: record.name,
          code: record.code,
          remarks: record.remarks ?? "",
          // isForAll is intentionally excluded from edit
        });
      } else {
        form.resetFields();
        if (initialValues) {
          form.setFieldsValue(initialValues);
        }
      }
    }
  }, [visible, record, form, initialValues]);

  // ── Submit ──────────────────────────────────────────────────────────────────
  // const handleOk = () => {
  //     form
  //         .validateFields()
  //         .then((values) => {
  //             onCreate(values);
  //         })
  //         .catch((info) => {
  //             console.log("Validate Failed:", info);
  //         });
  // };

  const handleOk = async () => {
    const values = await form.validateFields();
    await onCreate(values);
    form.resetFields();
  };

  // ── Cancel ──────────────────────────────────────────────────────────────────
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      open={visible}
      title={record?.id ? "Update Color" : "Add Color"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={handleCancel}
      onOk={handleOk}
      width={700}
      zIndex={99999}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        name="color_form"
        initialValues={{ isForAll: true }}
      >
        <Row gutter={16}>
          {/* ── Name (required) ─────────────────────────────────────────────── */}
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                { required: true, message: "Name is required" },
                { type: "string", message: "Name should be a string" },
              ]}
            >
              <Input placeholder="Enter color name" />
            </Form.Item>
          </Col>

          {/* ── Code (required) ──────────────────────────────────────────────── */}
          <Col span={12}>
            <Form.Item name="code" label="Code">
              <Input placeholder="Enter color code (e.g. #FF0000)" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          {/* ── Remarks (optional) ───────────────────────────────────────────── */}
          <Col span={record ? 24 : 12}>
            <Form.Item
              name="remarks"
              label="Remarks"
              rules={[
                { type: "string", message: "Remarks should be a string" },
              ]}
            >
              <Input.TextArea placeholder="Enter remarks (optional)" rows={3} />
            </Form.Item>
          </Col>

          {/* ── isForAll (only shown on Add, not on Update) ──────────────────── */}
          {!record?.id && (
            <Col span={12}>
              <Form.Item
                name="isForAll"
                label="Add For All"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default ColorsForm;
